// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAsts } from "../../../icons/full/build/icon-asts.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AstsIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAsts.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AstsIcon.displayName = 'AstsIcon';
}

export default AstsIcon;